import { backendApi } from "@/services/api";
import { Filter } from "@/shared/lib/filter/filter";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { Batch } from "./batch";
import { GrowthMedium, SampleType } from "../../types";

const batchesApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    listBatches: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/batches`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["Batches"],
    }),
    getBatch: build.query<Batch, GetRequest>({
      query: (request) => ({
        url: `/batches/${request.id}`,
        method: "GET",
        params: request,
      }),
      providesTags: (_result, _e, request) => [
        { type: "Batches", id: request.id },
      ],
    }),
    putBatch: build.mutation<Batch, PutRequest>({
      query: (request) => ({
        url: `/batches`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Batches"],
    }),
    deleteBatch: build.mutation<DeleteResponse, DeleteRequest>({
      query: (request) => ({
        url: `/batches`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["Batches"],
    }),
  }),
});

export const {
  usePutBatchMutation,
  useGetBatchQuery,
  useListBatchesQuery,
  useDeleteBatchMutation,
} = batchesApi;

export interface PutRequest {
  batch: Batch;
}

export interface GetRequest {
  id: string;
}

export interface ListRequest {
  batchNumber?: Filter<string>;
  growthMedium?: Filter<GrowthMedium>;
  sampleType?: Filter<SampleType>;
  orderBy?: OrdrBy<string>[];
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: Batch[];
}

export interface DeleteRequest {
  id: string;
}

export interface DeleteResponse {}
